export {isFlexiCurrency, isValidFlexiCurrencyAmount, isPerksCurrency, isRewardCurrency} from "./currencyChecks"
